import python from '../../Assets/python.png';
import digital from '../../Assets/digital.png';
import excel from '../../Assets/excel.png';
import machine_learning from '../../Assets/machine_learning.png'



let CertificationData = [
    {
        picture: python,
        Duration: "8 weeks",
        title: "Python programming",
        company: "Beanget It solution pvt.Ltb.",
        rating: 4.1
        
    },

    {
        picture: digital,
        Duration: "6 weeks",
        title: "Web Development",
        company: "Beanget It solution pvt.Ltb.",
        rating: 4.1
    },

    {
        picture: excel,
        Duration: "4 weeks",
        title: "Advanced Excel",
        company: "Beanget It solution pvt.Ltb.",
        rating: 4.1
    },

    {
        picture: machine_learning,
        Duration: "8 weeks",
        title: "Machine Learning",
        company: "Beanget It solution pvt.Ltb.",
        rating: 4.1
    }
    ,

    {
        picture: machine_learning,
        Duration: "8 weeks",
        title: "Machine Learning",
        company: "Beanget It solution pvt.Ltb.",
        rating: 4.1
    }
    ,

    {
        picture: machine_learning,
        Duration: "8 weeks",
        title: "Machine Learning",
        company: "Beanget It solution pvt.Ltb.",
        rating: 4.1
    }
    
]
export default CertificationData;
